import { ICourse, IActiveCourses } from '@interfaces/ICourse';
import { IFormErrors } from '@interfaces/IFormsErrors';
import { Action } from '@ngrx/store';

export enum ECoursesViewActions {
  GetCoursesRequest = '[Courses] Get Request',
  GetCoursesSuccess = '[Courses] Get Success',
  GetCoursesFailure = '[Courses] Get Failure',
  ClearCourses = '[Courses] Clear Courses',

  GetCourseDetailRequest = '[Course] Get Detail Request',
  GetCourseDetailSuccess = '[Course] Get Detail Success',
  GetCourseDetailFailure = '[Course] Get Detail Failure',
  ClearCourseDetail = '[Course] Clear Course Detail',

  GetActiveCoursesRequest = '[Courses] Get Active Request',
  GetActiveCoursesSuccess = '[Courses] Get Active Success',
  GetActiveCoursesFailure = '[Courses] Get Active Failure',
  ClearActiveCourses = '[Courses] Clear Active Courses',

  GetInactiveCoursesRequest = '[Courses] Get Inactive Request',
  GetInactiveCoursesSuccess = '[Courses] Get Inactive Success',
  GetInactiveCoursesFailure = '[Courses] Get Inactive Failure',

  SetCurrentCourseId = '[Courses] Set Current Course ID',
}

export class GetCoursesRequest implements Action {
  public readonly type = ECoursesViewActions.GetCoursesRequest;
  constructor(public qParams?: { [key: string]: string | boolean }) {}
}

export class GetCoursesSuccess implements Action {
  public readonly type = ECoursesViewActions.GetCoursesSuccess;

  constructor(public courses: ICourse[]) {}
}

export class GetCoursesFailure implements Action {
  public readonly type = ECoursesViewActions.GetCoursesFailure;
}

export class ClearCourses implements Action {
  public readonly type = ECoursesViewActions.ClearCourses;
}

export class GetCourseDetailRequest implements Action {
  public readonly type = ECoursesViewActions.GetCourseDetailRequest;

  constructor(public id: number) {}
}

export class GetCourseDetailSuccess implements Action {
  public readonly type = ECoursesViewActions.GetCourseDetailSuccess;

  constructor(public course: ICourse) {}
}

export class GetCourseDetailFailure implements Action {
  public readonly type = ECoursesViewActions.GetCourseDetailFailure;

  constructor(public error: IFormErrors) {}
}

export class ClearCourseDetail implements Action {
  public readonly type = ECoursesViewActions.ClearCourseDetail;
}

export class GetActiveCoursesRequest implements Action {
  public readonly type = ECoursesViewActions.GetActiveCoursesRequest;
  constructor(public qParams?: { [key: string]: string | boolean }) {}
}

export class GetActiveCoursesSuccess implements Action {
  public readonly type = ECoursesViewActions.GetActiveCoursesSuccess;

  constructor(public courses: IActiveCourses) {}
}

export class GetActiveCoursesFailure implements Action {
  public readonly type = ECoursesViewActions.GetActiveCoursesFailure;

  constructor(public error: IFormErrors) {}
}

export class ClearActiveCourses implements Action {
  public readonly type = ECoursesViewActions.ClearActiveCourses;
}

export class GetInactiveCoursesRequest implements Action {
  public readonly type = ECoursesViewActions.GetInactiveCoursesRequest;
}

export class GetInactiveCoursesSuccess implements Action {
  public readonly type = ECoursesViewActions.GetInactiveCoursesSuccess;

  constructor(public courses: IActiveCourses) {}
}

export class GetInactiveCoursesFailure implements Action {
  public readonly type = ECoursesViewActions.GetInactiveCoursesFailure;

  constructor(public error: IFormErrors) {}
}

export class SetCurrentCourse implements Action {
  public readonly type = ECoursesViewActions.SetCurrentCourseId;

  constructor(public payload: number | null) {}
}

export type CoursesViewActions =
  | GetCoursesRequest
  | GetCoursesSuccess
  | GetCoursesFailure
  | ClearCourses
  | GetCourseDetailRequest
  | GetCourseDetailSuccess
  | GetCourseDetailFailure
  | ClearCourseDetail
  | GetActiveCoursesRequest
  | GetActiveCoursesSuccess
  | GetActiveCoursesFailure
  | ClearActiveCourses
  | GetInactiveCoursesRequest
  | GetInactiveCoursesSuccess
  | GetInactiveCoursesFailure
  | SetCurrentCourse;
